module.exports = {
      id: "icon-a-check-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-a-check",
      toString: function () {
        return this.url;
      }
    }